import type { ActionFlowState, DispatchAction } from '../types.action-flow'

export function actionFlowReducer(state: ActionFlowState, action: DispatchAction): ActionFlowState {
  switch (action.type) {
    case 'START_EXECUTION':
      return state.flowState === 'idle'
        ? { flowState: 'execution', stepIndex: state.stepIndex, stepState: 'pending-wallet' }
        : state
    case 'PENDING_TX':
      return state.flowState === 'execution'
        ? {
            flowState: 'execution',
            stepIndex: state.stepIndex,
            stepState: 'pending-transaction',
            pendingTxHash: action.txHash,
            ...(action.safeTxHash && { pendingSafeTxHash: action.safeTxHash })
          }
        : state
    case 'FINALIZING':
      return state.flowState === 'execution'
        ? { flowState: 'execution', stepIndex: state.stepIndex, stepState: 'finalizing' }
        : state
    case 'COMPLETE_STEP':
      return state.flowState === 'execution'
        ? {
            flowState: 'execution',
            stepIndex: state.stepIndex + 1,
            stepState: 'pending-wallet'
          }
        : state
    case 'ERROR':
      return {
        flowState: 'idle',
        stepIndex: state.stepIndex,
        errorMessage: action.errorMessage,
        ...(action.isRetryBlocked && { isRetryBlocked: true })
      }
    case 'SUCCESS':
      return { flowState: 'success', stepIndex: state.stepIndex, txHash: action.txHash }
    case 'REVERT':
      return {
        flowState: 'reverted',
        stepIndex: state.stepIndex,
        txHash: action.txHash,
        errorName: action.errorName
      }
    case 'RESET':
      return { flowState: 'idle', stepIndex: 0 }
    case 'USER_REJECTED':
      return { flowState: 'idle', stepIndex: state.stepIndex }
    case 'CLEAR_FLOW':
      return state.flowState === 'execution' ? state : { flowState: 'idle', stepIndex: 0 }
  }
}
